import React, { useEffect, useRef, useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIData, JSXUIDebugTemplate } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import CoreGeneralButton from '../../core-general-button';
import CoreGeneralButton2, { AllButton2Types, GeneralButton2Type } from '../../core-general-button2';
import CoreGeneralButton3, { AllButton3Types, GeneralButton3Type } from '../../core-general-button3';
import * as ReactDOMServer from 'react-dom/server';
import "./core-debug-animations-window.css"
import CoreGeneralButton4, { AllButton4Types, GeneralButton4Type } from '../../core-general-button4';
import CoreDebugSideMenu from './core-debug-dropdown-window';
import { AnimationState } from '../../../../../UI/Animation/animation-base';
import { AllModalAnimations, AnimationModal, AnimationModalType } from '../../../../../UI/Animation/animation-modal';

enum AnimationWindowType {
	None = "None",
	Modal = "Modal",
	Button2 = "Button 2",
	Button3 = "Button 3",
	Button4 = "Button 4"
}

const allWindows = [
	AnimationWindowType.Modal,
	AnimationWindowType.Button2,
	AnimationWindowType.Button3,
	AnimationWindowType.Button4
]

const CoreDebugAnimationsWindow = (props: CoreDebugAniamtionsWindowConfig) => {
	const [animationWindowType, setAnimationWindowType] = useState(AnimationWindowType.None);
	const [animationSelectedIndex, setAnimationSelectedIndex] = useState(0);
	const [isModalShowing, setIsModalShowing] = useState(false);
	const renderWindowTypeNone = () => {
		return (
			<div className='core-debug-ui-general-window' style={{ width: '900px', height: '900px', 'overflow': 'auto' }}>
				<div key={Tools.generateGuid()} style={{
					marginTop: '10px'
				}}>
					{allWindows.map((item: AnimationWindowType, indx: number) => {
						return (
							<CoreGeneralButton width='100%'
								height='50px'
								onClick={() => {
									setAnimationWindowType(item);
								}}
								onRenderContent={() => {
									return (
										<p className='center-element' style={{ textAlign: 'center' }}>{item}</p>
									)
								}}
								isSelected={false}
								isDisabled={false}
								ariaLabel={''}></CoreGeneralButton>
						)
					})}
				</div>

			</div>
		);
	};

	const renderWindowTypeModal = () => {
		const component = (<ExampleModalComponent currentAnimation={AllModalAnimations[animationSelectedIndex].key} onDismissClicked={() => {setIsModalShowing(false)}} ></ExampleModalComponent>)

		const componentAsString = 
			`
			<ExampleModalComponent currentAnimation={${AllModalAnimations[animationSelectedIndex].value}} onDismissClicked={() => {alert('Dismissed')}} ></ExampleModalComponent>
			export const ExampleModalComponent = (props: ExampleModalComponentUIConfig) => {
				const [animation, setAnimation] = useState(new AnimationModal(props.currentAnimation));
				const modalRoot = useRef(null);
				const modalContainer = useRef(null);
				useEffect(() => {
					animation.updateProps({
						modalRoot: modalRoot.current,
						modalContainer: modalContainer.current,
						// backgroundContentRoot: document.getElementsByTagName('video')[0]
					});
				}, [])
				return (
					<div className={"modal-disable-select center-element"} style={{
						width: '100%',
						height: '100%',
						pointerEvents: 'all'
					}}>
						<div ref={modalRoot} className={'black-overlay ' + animation.getModalBackgroundOverlayInitialClass()} style={{ width: '100%', height: '100%', position: 'absolute' }}>
			
						</div>
						<div ref={modalContainer} style={{
							width: '614px',
							height: '283px'
						}} className={animation.getModalContainerInitialClass()}>
							<div className="modal-disable-select center-element main-content opaque" style={{
								width: '100%',
								height: '100%',
								position: 'absolute'
							}}>
								<div style={{
									position: 'relative'
								}}>
									<h1 tabIndex={0} className='' style={{
										marginLeft: '10px',
										textAlign: 'center'
									}}>Example Popup</h1>
								</div>
			
								<div style={{
									marginBottom: '10px',
									position: 'relative',
									textAlign: 'center',
									width: '100%',
									height: '70%'
								}}>
									<div style={{
										marginTop: '10px',
										width: '100%',
										height: '180px'
									}}>
										<p className='small-text' style={{ textAlign: 'center' }}>
											This is some sample text
										</p>
										<div style={{
											position: 'absolute',
											bottom: '0',
											left: '60px',
											width: '80%',
											height: '60px'
										}}>
											<CoreGeneralButton width='100%'
												height='100%'
												onClick={() => {
													animation.setState(AnimationState.Out, () => {
														props.onDismissClicked();
													})
												}}
												onRenderContent={() => {
													return (
														<div className='center-element' style={{
															position: 'absolute',
															width: '100%'
														}}>
															<p className='small-text'>Click to play dismiss aniamtion</p>
														</div>
													)
												}}
												isSelected={false}
												ariaLabel='Button 1'></CoreGeneralButton>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			}
			
			export interface ExampleModalComponentUIConfig  {
				currentAnimation: AnimationModalType;
				onDismissClicked: () => void;
			}
			`;
		return (
			<div>
				{isModalShowing ? <div style={{
					width: '100%',
					height: '100%',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div> : (null)}
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'

				}}>
					<CoreDebugSideMenu onIndexChanged={(indx: number) => {
						setAnimationSelectedIndex(indx);
					}} defaultVal={AllModalAnimations[animationSelectedIndex].key} allValues={AllModalAnimations} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
					<div style={{
						backgroundColor: 'rgba(0,0,0,0.5)'
					}}>
						<CoreGeneralButton width='100%'
							height='50px'
							onClick={() => {
								setIsModalShowing(!isModalShowing);
							}}
							onRenderContent={() => {
								return (
									<p className='center-element' style={{ textAlign: 'center' }}>Click to play enter animation</p>
								)
							}}
							isSelected={false}
							isDisabled={isModalShowing}
							ariaLabel={''}></CoreGeneralButton>
					</div>
				</div>
			</div>
		)
	};

	const renderWindowTypeButton2 = () => {
		const button = (<CoreGeneralButton2 type={AllButton2Types[animationSelectedIndex].key} onClick={() => {
			alert('clicked')
		}} onRenderContent={() => {
			return <p className='' style={{color: 'white'}}>Test Content</p>
		}} onRenderSecondaryContent={() => {
			return <p className='' style={{color: 'white'}}>Click Me!!</p>
		}}></CoreGeneralButton2>)

		const buttonAsString = 
			`
				<CoreGeneralButton2 type={${AllButton2Types[animationSelectedIndex].value}} onClick={() => {
					alert('clicked')
				}} onRenderContent={() => {
					return <p className='' style={{ color: 'white' }}>Test Content</p>
				}} onRenderSecondaryContent={() => {
					return <p className='' style={{ color: 'white' }}>Click Me!!</p>
				}}></CoreGeneralButton2>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu onIndexChanged={(indx: number) => {
						setAnimationSelectedIndex(indx);
					}} defaultVal={AllButton2Types[animationSelectedIndex].key} allValues={AllButton2Types} codeSnippet={(buttonAsString)}></CoreDebugSideMenu>

				</div>
				<div style={{
					width: '300px',
					height: '100px',
					position: 'absolute',
				}} className="center-element">
					{button}
				</div>
			</div>
		)
	};
	const renderWindowTypeButton3 = () => {
		const button = (<CoreGeneralButton3 type={AllButton3Types[animationSelectedIndex].key} onClick={() => {
			alert('clicked')
		}} onRenderContent={() => {
			return <p className='' style={{color: 'white'}}>Some Content</p>
		}}></CoreGeneralButton3>)

		const buttonAsString = 
			`
				<CoreGeneralButton3 type={${AllButton3Types[animationSelectedIndex].value}} onClick={() => {
					alert('clicked')
				}} onRenderContent={() => {
					return <p className='' style={{color: 'white'}}>Some Content</p>
				}}></CoreGeneralButton3>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu onIndexChanged={(indx: number) => {
						setAnimationSelectedIndex(indx);
					}} defaultVal={AllButton3Types[animationSelectedIndex].key} allValues={AllButton3Types} codeSnippet={(buttonAsString)}></CoreDebugSideMenu>

				</div>
				<div style={{
					width: '300px',
					height: '100px',
					position: 'absolute',
				}} className="center-element">
					{button}
				</div>
			</div>
		)
	};
	const renderWindowTypeButton4 = () => {
		const button = (<CoreGeneralButton4 type={AllButton4Types[animationSelectedIndex].key} onClick={() => {
			alert('clicked')
		}} text="Some Content"></CoreGeneralButton4>)

		const buttonAsString = 
			`
				<CoreGeneralButton4 type={${AllButton4Types[animationSelectedIndex].value}} onClick={() => {
					alert('clicked')
				}} text="Some Content"></CoreGeneralButton4>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu onIndexChanged={(indx: number) => {
						setAnimationSelectedIndex(indx);
					}} defaultVal={AllButton4Types[animationSelectedIndex].key} allValues={AllButton4Types} codeSnippet={(buttonAsString)}></CoreDebugSideMenu>

				</div>
				<div style={{
					width: '300px',
					height: '100px',
					position: 'absolute',
				}} className="center-element">
					{button}
				</div>
			</div>
		)
	};
	const renderWindow = () => {
		switch (animationWindowType) {
			case AnimationWindowType.None:
				return renderWindowTypeNone()
			case AnimationWindowType.Modal:
				return renderWindowTypeModal()
			case AnimationWindowType.Button2:
				return renderWindowTypeButton2();
			case AnimationWindowType.Button3:
				return renderWindowTypeButton3();
			case AnimationWindowType.Button4:
				return renderWindowTypeButton4();
		}
	};
	return (
		<div className='core-debug-ui-animations-window core-debug-ui-general-window'>
			<div className='core-debug-ui-back-bttn'>
				<CoreGeneralButton width='100%'
					height='100%'
					onClick={animationWindowType === AnimationWindowType.None ? props.onBackToMainWindowClicked : () => {
						setAnimationWindowType(AnimationWindowType.None);
					}}
					onRenderContent={() => {
						return (
							<p className='center-element'>{animationWindowType === AnimationWindowType.None ? 'Back to Main Window' : 'Back to Animations'}</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={'Back to Main Window'}></CoreGeneralButton>
			</div>

			{renderWindow()}
		</div>
	);
}

export interface CoreDebugAniamtionsWindowConfig {
	showWindowBackground: boolean;
	gameManager: GameManager;
	onBackToMainWindowClicked: () => void;
	onTestEnvironmentSpawned: () => void;
	setForceUpdate: () => void;
}

export default CoreDebugAnimationsWindow;

export const ExampleModalComponent = (props: ExampleModalComponentUIConfig) => {
	const [animation, setAnimation] = useState(new AnimationModal(props.currentAnimation));
	const modalRoot = useRef(null);
	const modalContainer = useRef(null);
	useEffect(() => {
		animation.updateProps({
			modalRoot: modalRoot.current,
			modalContainer: modalContainer.current,
			// backgroundContentRoot: document.getElementsByTagName('video')[0]
		});
	}, [])
	return (
		<div className={"modal-disable-select center-element"} style={{
			width: '100%',
			height: '100%',
			pointerEvents: 'all'
		}}>
			<div ref={modalRoot} className={'black-overlay ' + animation.getModalBackgroundOverlayInitialClass()} style={{ width: '100%', height: '100%', position: 'absolute' }}>

			</div>
			<div ref={modalContainer} style={{
				width: '614px',
				height: '283px'
			}} className={animation.getModalContainerInitialClass()}>
				<div className="modal-disable-select center-element main-content opaque" style={{
					width: '100%',
					height: '100%',
					position: 'absolute'
				}}>
					<div style={{
						position: 'relative'
					}}>
						<h1 tabIndex={0} className='' style={{
							marginLeft: '10px',
							textAlign: 'center'
						}}>Example Popup</h1>
					</div>

					<div style={{
						marginBottom: '10px',
						position: 'relative',
						textAlign: 'center',
						width: '100%',
						height: '70%'
					}}>
						<div style={{
							marginTop: '10px',
							width: '100%',
							height: '180px'
						}}>
							<p className='small-text' style={{ textAlign: 'center' }}>
								This is some sample text
							</p>
							<div style={{
								position: 'absolute',
								bottom: '0',
								left: '60px',
								width: '80%',
								height: '60px'
							}}>
								<CoreGeneralButton width='100%'
									height='100%'
									onClick={() => {
										animation.setState(AnimationState.Out, () => {
											props.onDismissClicked();
										})
									}}
									onRenderContent={() => {
										return (
											<div className='center-element' style={{
												position: 'absolute',
												width: '100%'
											}}>
												<p className='small-text'>Click to play dismiss aniamtion</p>
											</div>
										)
									}}
									isSelected={false}
									ariaLabel='Button 1'></CoreGeneralButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export interface ExampleModalComponentUIConfig  {
	currentAnimation: AnimationModalType;
	onDismissClicked: () => void;
}